import mutations from './employabilityOpinion.mutations'
import actions from './employabilityOpinion.actions'
import getters from './employabilityOpinion.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
